import {css, keyframes} from '@emotion/css';
import {useMemo} from 'react';

import {useWolfTheme} from '../../../../contexts';

const useStyles = (open: boolean, subMenu: boolean) => {
    const theme = useWolfTheme();

    // eslint-disable-next-line i18next/no-literal-string
    const slide = keyframes(`
        from 1% to {
            transform: translateX(0%);
        }

        100% {
            transform: translateX(100%);
        }
    `);

    // eslint-disable-next-line i18next/no-literal-string
    const fade = keyframes(`
        from 1% to {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    `);

    return useMemo(
        () => ({
            wrapper: css({
                position: 'fixed',
                display: 'flex',
                flexDirection: 'column',
                height: '100dvh',
                width: 300,
                left: !subMenu ? -300 : 300,
                top: 0,
                backgroundColor: !subMenu ? theme.palette.background.container : theme.palette.background.default,
                zIndex: 1,

                animation: !subMenu ? `${slide} 300ms ease forwards` : '',
            }),

            overline: css({
                fontSize: theme.typography.size0,
                color: theme.palette.foreground.default,
            }),

            group: css({
                marginBottom: theme.orbitalFour,
                display: 'flex',
                flexDirection: 'column',
                gap: theme.orbitalOne,
            }),

            hideButton: css({
                visibility: 'hidden',
                opacity: 0,
            }),

            heading: css({
                padding: '12px 16px',
                display: 'flex',
                boxSizing: 'border-box',
                alignItems: 'center',
                justifyContent: 'space-between',
                borderBottom: `1px solid ${theme.palette.stroke.default}`,
                color: theme.palette.foreground.default,
            }),

            nav: css({
                display: 'flex',
                flexDirection: 'column',
                gap: theme.orbitalTwo,
            }),

            companyNav: css({
                display: 'flex',
                flexDirection: 'column',
                gap: theme.orbitalTwo,

                p: {
                    color: theme.palette.foreground.default,
                    fontSize: theme.typography.size0,
                },
            }),

            inner: css({
                padding: theme.orbitalFour,
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
                height: '100%',
                boxSizing: 'border-box',
            }),

            toggle: css({
                '& > svg': {
                    fill: theme.palette.foreground.default + '!important',
                    color: theme.palette.foreground.default + '!important',
                },
            }),

            backdrop: css({
                position: 'fixed',
                width: '100vw',
                height: '100dvh',
                background: 'rgba(33, 33, 33, 0.5)',
                top: 0,
                left: 0,
                backdropFilter: 'blur(2px)',
                animation: !subMenu ? `${fade} 300ms ease forwards` : '',
                opacity: 0,
                display: open ? 'block' : 'none',
            }),
        }),
        [
            subMenu,
            theme.palette.background.container,
            theme.palette.background.default,
            theme.palette.foreground.default,
            theme.palette.stroke.default,
            theme.typography.size0,
            theme.orbitalFour,
            theme.orbitalOne,
            theme.orbitalTwo,
            slide,
            fade,
            open,
        ]
    );
};

export default useStyles;
